var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { cloneDeep } from "lodash";
export var getOrderedMobileTiles = function (tiles) {
    if (tiles === void 0) { tiles = []; }
    // Clone tile array and remove temp placeholder tile if it exists
    var orderedMobileTiles = cloneDeep(tiles).filter(function (tile) { return tile.id !== "temp"; });
    // Sort the widgets based on y position first, followed by x position
    orderedMobileTiles.sort(function (a, b) {
        return a.layouts.desktop.yOffset - b.layouts.desktop.yOffset || a.layouts.desktop.xOffset - b.layouts.desktop.xOffset;
    });
    return orderedMobileTiles.map(function (tile) {
        return __assign(__assign({}, tile), { layouts: undefined, width: tile.layouts.desktop.width, height: tile.layouts.desktop.height });
    });
};
